<template>
  <v-container class="ma-0 pa-0 mw-100">
    <v-row>
      <v-col cols="6" sm="6"> </v-col>
      <v-col cols="6" sm="6">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('AdminPage.Search')"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col col="12" sm="12">
        <v-data-table
          :search="search"
          :custom-filter="customDataTableItemsFilter"
          :headers="headers"
          :items="items"
          :item-class="itemClass"
          :show-select="showSelect"
          v-model="selectedItems"
          item-key="user_id"
          sort-by="first_name"
          class="elevation-1"
          :footer-props="{
            disableItemsPerPage: true,
            itemsPerPageOptions: [],
            itemsPerPageText: '',
          }"
        >
          <v-progress-linear
            v-slot:progress
            color="mainColor"
            indeterminate
          ></v-progress-linear>
          <template v-if="!mobile" v-slot:header.delete>
            <button @click="deleteSelected">
              <v-icon>{{ "mdi-delete-outline" }}</v-icon>
            </button>
          </template>
          <template v-if="!mobile" v-slot:item.delete="{ item }">
            <v-checkbox
              v-model="checked"
              dense
              @change="selectItem(item)"
            ></v-checkbox>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip
              top
              v-for="action in item.dropdown_items"
              :key="action.key"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  @click="$emit(action.function, item)"
                  :disabled="action.disabled"
                  class="custom-icon2"
                  v-bind="attrs"
                  v-on="on"
                  v-if="!action.textButton"
                >
                  {{ action.icon }}
                </v-icon>
                <custom-button
                  :text="action.text"
                  :disabled="action.disabled"
                  v-if="action.textButton"
                  @click="$emit(action.function, item)"
                />
              </template>
              <span>{{ action.title }}</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            {{ $t("AdminPage.no_data") }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CustomButton from "../input/CustomButton";
import { log } from "../../../helpers/logger";

/**
 * @vue-prop {String} search - search input
 * @vue-prop {Array} items - table input
 * @vue-data {Array} user_fields - table header
 * @vue-data {String} mainColor - stores the main color
 * @vue-data {Boolean}[checked=false] - stores, selected rows data
 * @vue-data {Array} selectedItems - stores all selected items
 * @vue-event {Object} selectItem(item) - selects item and stores item data
 * @vue-event {} deleteSelected() - deletes selected user
 */

export default {
  name: "custom-table",
  props: {
    search: String,
    column: String,
    showSelect: Boolean,
    disabled: Boolean,
    textButton: Boolean,
    items: Array,
    headers: Array,
    buttons: Array,
    itemClass: Function,
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      color: "",
      checked: false,
      selectedItems: [],
      mobile: false,
    };
  },
  watch: {
    items() {},
  },
  created() {
    this.textColor = this.isText ? "brown--text" : "white--text";
    this.color = this.$vuetify.theme.themes.light.primary;

    this.mobile = this.$vuetify.breakpoint.mdAndDown;
  },
  methods: {
    customDataTableItemsFilter(value, search, items) {
      const wordArray = search
        .toString()
        .toLowerCase()
        .split(" ")
        .filter((x) => x);
      return wordArray.every((word) =>
        JSON.stringify(Object.values(items))
          .toString()
          .toLowerCase()
          .includes(word)
      );
    },
    selectItem(item) {
      log("ui.other.CustomTable.selectItem - select " + item.user_id, "info");
      if (this.checked) {
        this.selectedItems.push(item.user_id);
        this.checked = false;
      } else {
        const index = this.selectedItems.indexOf(item.user_id);
        if (index > -1) {
          this.selectedItems.splice(index, 1);
        }
      }
    },
    deleteSelected() {
      log(
        "ui.other.CustomTable.deleteSelected - delete item " +
          this.selectedItems,
        "info"
      );
      this.$emit("delete", this.selectedItems);
    },
  },
};
</script>
